import React from 'react';
import ReactPlayer from 'react-player'
import ButtonMailto from '../fullpage/page5/buttonEmail';

itemInfo.propTypes = {

};

function itemInfo(props) {
    return (
        <div className="cover-item-info">
            <div className="cover-player">
                <ReactPlayer controls={true} className="player" url={props.itemDatas[props.itemClickedIndex].videoLink} />
            </div>
            <div className="cover-item-content">
                <p className="name-tag">{props.itemDatas[props.itemClickedIndex].tag}</p>
                <p className="name-game">{props.itemDatas[props.itemClickedIndex].gameName}</p>
            </div>
            <div className="contact-us">
                <ButtonMailto mailto="mailto:kendidang2k@gmail.com" label="Contact us"></ButtonMailto>
            </div>
        </div>
    );
}

export default itemInfo;